/**
 * iDiamonds — asigurarea coletului.
 *
 * 1. O singură bifă, ca la gravură, garanție și ambalaj.
 * 2. La submit-ul formularului de produs (capture, ca în custom-engraving.js)
 *    reține doar dacă bifa era pusă.
 * 3. După ce produsul intră în coș (eveniment `product-ajax:added`), adaugă
 *    produsul-taxă — o singură bucată, și doar dacă coșul nu e deja asigurat.
 *
 * Asigurarea ține de colet, nu de bijuterie, deci NU poartă `_pentru_varianta`:
 * legată de o variantă, ar dispărea când clientul scoate produsul de pe care a
 * bifat-o, deși coletul cu restul produselor tot pleacă. Poartă în schimb
 * marcajul ascuns `_asigurare_colet`, după care cart-linked-items.js o
 * plafonează la 1 pe tot coșul și o scoate când nu mai rămâne niciun produs.
 *
 * Verificarea „coșul e deja asigurat" de aici e doar ca clientul să nu vadă
 * pentru o clipă 2 × 10 lei în drawer. Garanția reală e plafonul din
 * cart-linked-items.js: Shopify contopește două adăugări cu aceeași variantă și
 * aceleași proprietăți, deci două taburi deschise tot ar ajunge la cantitate 2.
 *
 * Fără localStorage: în preview/theme editor storefront-ul rulează în iframe
 * unde localStorage poate fi blocat.
 */
const INSURANCE_PROPERTY = '_asigurare_colet';

class ShippingInsurance extends HTMLElement {
  connectedCallback() {
    this.form = document.getElementById(this.dataset.formId);
    this.variantId = this.dataset.variantId;
    this.checkbox = this.querySelector('.shipping-insurance__checkbox');

    if (!this.form || !this.variantId || !this.checkbox) return;

    this.pending = false;

    this._onSubmit = this._onSubmit.bind(this);
    this._onProductAdded = this._onProductAdded.bind(this);

    this.form.addEventListener('submit', this._onSubmit, true);
    document.addEventListener('product-ajax:added', this._onProductAdded);
  }

  disconnectedCallback() {
    if (this.form) this.form.removeEventListener('submit', this._onSubmit, true);
    document.removeEventListener('product-ajax:added', this._onProductAdded);
  }

  _onSubmit() {
    // Se resetează la fiecare încercare de adăugare în coș.
    this.pending = this.checkbox.checked;
  }

  _onProductAdded() {
    if (!this.pending) return;
    this.pending = false;
    this._addInsurance();
  }

  async _addInsurance() {
    const linkedItems = window.iDiamonds.linkedItems;
    try {
      const cart = await linkedItems.fetchCart();
      const isInsured = cart.items.some((item) => item.properties && item.properties[INSURANCE_PROPERTY]);
      if (!isInsured) {
        await linkedItems.add({
          variantId: this.variantId,
          quantity: 1,
          properties: { [INSURANCE_PROPERTY]: '1' },
        });
      }
      this.checkbox.checked = false;
    } catch (error) {
      console.error('Asigurare colet — adăugare eșuată:', error);
    }
  }
}

if (!customElements.get('shipping-insurance')) {
  customElements.define('shipping-insurance', ShippingInsurance);
}
